//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Picker, Popup, Switch, Uploader, Toast, Loading } from "vant";
import global from "../../../static/js/global.js";
import $ from "jquery";
import Exif from "exif-js";
export default {
  components: {
    $,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Switch.name]: Switch,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Loading.name]: Loading
  },
  data() {
    return {
      //防止保存重复点击
      repeatClick: true,
      items:'',
      columns: ["本人", "父母", "子女", "兄妹", "其他"],
      showQR: false,
      checked: false,
      imgUrl: "", // 选择后头像的64位编码
      showuser: "", // 选择联系人后的值 1：亲戚；2：朋友；3：同事；4：其他
      rename: "", // 成员姓名
      headerImage: "", // 图片集合
      picValue: "", // 需要转换的图片
      wuzhImg: "", // 没有转换过的图片64位
      access_token: "", // 百度api的token
      pass: false, // 此参数为true 执行向后台提交的请求 次参数为false 则拦截在百度AI这一层
      faceList:'',// 脸部识别所有的数据
    };
  },
  watch:{
    items(){
      if(this.items.length > 4){
        this.items = this.items.substring(0,4)
      }
    }
  },
  beforeMount() {
    this.getBadToken();
  },
  mounted() {
    // this.getBadToken()
    console.log(this.$route.query.hsName); //业主姓名
    console.log(this.$route.query.hsNo); // 房间号
    console.log(this.$route.query.comnCode); // 小区编号
  },
  methods: {
    showUserPicker() {
      this.showQR = true;
    },
    onConfirm(value, index) {
      this.showQR = false;
      this.$refs.showUser.value = value;
      if (value == "本人") {
        this.showuser = "0";
      }else if(value == "夫妻"){
        this.showuser = "0";
      } else if (value == "父母") {
        this.showuser = "1";
      } else if (value == "子女") {
        this.showuser = "2";
      } else if (value == "兄妹") {
        this.showuser = "4";
      } else if (value == "其他") {
        this.showuser = "5";
      }
    },
    onCancel() {
      this.showQR = false;
    },
    onRead(file) {
      console.log("qqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqq");
      console.log(file);
      // 图片转换代码
      this.$refs.userImg.src = file.content;
      // this.wuzhImg = file.content;
      this.picValue = file.file;
      this.imgPreview(this.picValue);
      Toast.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "识别中..."
      });
    },

    // 图片压缩
    imgPreview(file) {
      let self = this;
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      Exif.getData(file, function() {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;

      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function() {
          let result = this.result;
          let img = new Image();
          img.src = result;
          //判断图片是否大于100K,是就直接上传，反之压缩图片
          if (this.result.length <= 100 * 1024) {
            self.headerImage = this.result;
            self.discern();
          } else {
            img.onload = function() {
              let data = self.compress(img, Orientation);
              self.headerImage = data;
              self.discern();
            };
          }
        };
      }
    },
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //        铺底色
      // ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //            计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3: //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 0.1);
      console.log("压缩前：" + initSize);
      console.log("压缩后：" + ndata.length);
      console.log(
        "压缩率：" + ~~((100 * (initSize - ndata.length)) / initSize) + "%"
      );
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    // 调用百度api 获取token
    getBadToken() {
      // 百度api
      // /BD 配置在config index.js文件内做跨域处理
      console.log("调用百度api token");
      this.$http.post(global.host + "/face/aip/access_token.json").then(
        function(res) {
          console.log("新的token新的token新的token新的token新的token新的token");
          console.log(res);
          this.access_token = res.body.access_token;
          console.log(this.access_token);
        },
        function(err) {
          console.log("人脸识别token获取失败");
          console.log(err);
        }
      );
    },
    // 唤起人脸识别检测接口
    discern() {
      this.pass = false
      console.log("唤起人脸识别检测接口");
      // console.log(this.headerImage)
      var strIng = this.headerImage.indexOf(",");
      var result = this.headerImage.substr(strIng + 1, this.headerImage.length);
      //  console.log(result)
      let self = this;
      $.ajax({
        type: "post",
        url:
          "https://aip.baidubce.com/rest/2.0/face/v3/detect?access_token=" +
          this.access_token,
        data: {
          image: result,
          image_type: "BASE64",
          face_field: "angel,quality,face_type,glasses,gender,age,face_token,eye_status,race,landmark,",
          max_face_num: "2"
        },
        dataType: "json",
        crossDomain: true,
        success: function(result) {
          console.log("百度AI调用成功返回参数");
          console.log(result);
          if (result.error_code == "222202") {
            Toast.fail("图片中没有人脸");

          } else if (result.error_code == "222203") {
            Toast.fail("无法解析人脸");
          } else if (result.error_code == "223114") {
            Toast.fail("人脸模糊");
          } else if (result.error_code == "223115") {
            Toast.fail("人脸光照不好");
          } else if (result.result.face_list[0].face_type.type == "cartoon") {
            Toast.fail("请上传真实人脸");
          } else if (result.result.face_list[0].face_type.probability <= "0.85"  ) {
            Toast.fail("请不要使用美颜拍照");
          }else if (result.result.face_list[0].quality.completeness != "1") {
            Toast.fail("人脸不完整");
          } else if (result.result.face_list[0].face_probability != "1") {
            Toast.fail("人脸模糊");
          } else if (result.result.face_list[0].quality.blur != "0") {
            Toast.fail("相片不够清晰");
          } else if (result.result.face_list[0].quality.completeness != "1") {
            Toast.fail("人脸不够完整");
          } else if (result.result.face_list[0].quality.illumination < 70) {
            Toast.fail("光照太弱");
          } else if (
            result.result.face_list[0].quality.occlusion.chin_contour > "0.4"
          ) {
            Toast.fail("下巴被遮挡");
          } else if (
            result.result.face_list[0].location.rotation < -50 || result.result.face_list[0].location.rotation > 50
          ) {
            Toast.fail("照片角度不符");
          }else if (
            result.result.face_list[0].quality.occlusion.left_cheek > "0.4"
          ) {
            Toast.fail("左脸颊被遮挡");
          } else if (
            result.result.face_list[0].quality.occlusion.left_eye > "0.4"
          ) {
            Toast.fail("左眼被遮挡");
          } else if (
            result.result.face_list[0].quality.occlusion.mouth > "0.4"
          ) {
            Toast.fail("嘴巴被遮挡");
          } else if (
            result.result.face_list[0].quality.occlusion.nose > "0.4"
          ) {
            Toast.fail("鼻子被遮挡");
          } else if (
            result.result.face_list[0].quality.occlusion.right_cheek > "0.4"
          ) {
            Toast.fail("右脸颊被遮挡");
          } else if (
            result.result.face_list[0].quality.occlusion.right_eye > "0.4"
          ) {
            Toast.fail("右眼被遮挡");
          } else if (result.result.face_num > "1") {
            Toast.fail("请单人拍照");
          } else if (
            result.result.face_list[0].glasses.type != "none"
          ) {
            Toast.fail("请摘下眼镜");
          }  else if (
            result.result.face_list[0].eye_status.left_eye != "1" && result.result.face_list[0].eye_status.right_eye != "1"
          ) {
            Toast.fail("请睁开眼睛拍照");
          } else if (
            // result.result.face_list[0].angle.pitch <= -10 ||
             result.result.face_list[0].angle.pitch >= 20
          ) {
            Toast.fail("照片角度不符");
          }else if (
            // result.result.face_list[0].angle.roll <= -20 ||
             result.result.face_list[0].angle.roll >= 20
          ) {
            Toast.fail("照片角度不符");
          }else if (
            //  result.result.face_list[0].angle.yaw <= -20 ||
              result.result.face_list[0].angle.yaw >= 20
          ) {
            Toast.fail("照片角度不符");
          }
          // else if (
          //   result.result.face_list[0].location.width > 850 || result.result.face_list[0].location.height > 850
          // ) {
          //   Toast.fail("请离摄像头远一点");
          // }
          else if (
            result.result.face_list[0].location.width < 200 || result.result.face_list[0].location.height < 200
          ) {
            Toast.fail("请不要使用全身照");
          } else {
            self.pass = true;
            Toast.success("照片合格");
          }
          if(self.pass == false){
            self.$refs.userImg.src = '../../../static/image/defaultImg.png'
          }
          this.headerImage = ''
          self.faceList = JSON.stringify(result);
          console.log('脸部特征')
          console.log(self.faceList)
        },
        error: function(result) {
          this.headerImage = '';
          self.pass = false;
          Toast.fail("上传失败,请重新上传");
          console.log(result);
        }
      });
    },
    //
    // 保存
    getSave() {
      if(!this.repeatClick){
        return;
      }
      // 判断必填选是否已选择
      if (this.headerImage == "") {
        Toast.fail("头像不能为空");
      } else if (this.$refs.rename.value == "") {
        Toast.fail("姓名不能为空");
      } else if (this.showuser == "") {
        Toast.fail("请选择关系");
      } else if (this.pass == false) {
        Toast.fail("图片不符合标准");
      } else {
        this.uploading();
      }
    },

    // 全部检测通过后 向服务器上传数据
    uploading() {
      //重复点击
      this.repeatClick = false;
      let isPush = "";
      if (this.checked == true) {
        // 推送
        isPush = "1";
      } else {
        isPush = "0";
      }
      Toast.loading({
        mask: true,
        forbidClick: true,
        duration: 10000000,
        message: "添加中..."
      });
      if(this.$refs.rename.value.length > 4){
        Toast('姓名长度不能超过4个字');
        //重复点击
        this.repeatClick = true;
        return;
      }
      var regRule = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
      if(this.$refs.rename.value.match(regRule)) {
        Toast('不支持表情');
        //重复点击
        this.repeatClick = true;
        return;
      }

      let msgHome = new Object();
      msgHome.comnCode = this.$route.query.comnCode;
      msgHome.phone = this.$router.history.current.query.phone;
      msgHome.hsNo = this.$route.query.hsNo;
      msgHome.relation = this.showuser; // 与我的关系
      msgHome.rename = this.$refs.rename.value; // 成员姓名
      msgHome.authImg = this.headerImage; // 成员照片
      msgHome.telephone = this.$refs.telephone.value; // 联系方式
      msgHome.hsName = this.$route.query.ownersName; // 业主姓名 ownersName
      msgHome.faceParam = this.faceList; // 数据集
      msgHome.isPush = isPush;
      console.log(msgHome);
      let newUrl = global.host + "guardInfo/addGuardInfo";
      this.$http.post(newUrl, msgHome).then(
        function(res) {
          console.log("添加后返回");
          console.log(res);
          if (res.body.statusCode == "120") {
            setTimeout(function() {
              Toast.success("网络错误,重新上传");
            }, 1000);
            //重复点击
            this.repeatClick = true;
          } else {
            setTimeout(function() {
              Toast.success(res.body.message);
            }, 1000);
            let this_ = this;
            setTimeout(function() {
              this_.$router.push({
                path: "/accessControl",
                query: {
                  ownersName: this_.ownersName,
                  hsNo: this_.hsNo,
                  comnCode: this_.comnCode,
                  openid: this_.$router.history.current.query.openid,
                  phone: this_.$router.history.current.query.phone
                }
              });
            }, 2000);
            //重复点击
            this.repeatClick = true;
          }
        },
        function(err) {
          //重复点击
          this.repeatClick = true;
          Toast.fail("添加失败,请重试");
          console.log(err);
        }
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/entrance/addFamily.vue